var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-2{stroke:#fff;}.cls-3{fill:#fff;fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_673",
    "data-name": "Group 673"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M50,0h0a50,50,0,0,1,50,50h0a50,50,0,0,1-50,50h0A50,50,0,0,1,0,50H0A50,50,0,0,1,50,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50,2.5h0A47.5,47.5,0,0,1,97.5,50h0A47.5,47.5,0,0,1,50,97.5h0A47.5,47.5,0,0,1,2.5,50h0A47.5,47.5,0,0,1,50,2.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    className: "cls-3",
    d: "M41.55,48.7V80.12a.82.82,0,0,0,.82.82H54a.81.81,0,0,0,.82-.82V48.2h8.46a.83.83,0,0,0,.82-.75L65,37.83a.82.82,0,0,0-.74-.89H54.86V30.1a2.9,2.9,0,0,1,2.9-2.9h6.5a.82.82,0,0,0,.82-.82h0V16.76a.82.82,0,0,0-.82-.82h-11A11.71,11.71,0,0,0,41.55,27.65v9.27H35.71a.82.82,0,0,0-.82.82h0v9.63a.82.82,0,0,0,.82.82h5.84Z"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.9845aed05b8f4d7245c3ffd054c4d9eb.svg";
export { ForwardRef as ReactComponent };